import { BarBorder, BarNumber, BarTextLeft, BarZone, LineBar } from "styles/bar";

import PropTypes from "prop-types";
import React from "react";
import colors from "styles/colors";
import formatNumber from "../../modules/utils/formatNumber";

const KeywordBar = ({ barHeight = 20, value1, value2, text1, text2 }) => {
  return (
    <>
      <BarZone width={50}>
        <BarBorder height={barHeight}>
          <LineBar bgColor={colors.averageBar}>
            <BarTextLeft space={32} color={colors.primary}>
              {text1}
            </BarTextLeft>
          </LineBar>
        </BarBorder>
      </BarZone>
      <BarZone marginTop={8}>
        <BarBorder height={barHeight} width={(value2 / value1) * 50}>
          <LineBar bgColor={colors.negativeBar}>
            <BarTextLeft space={32} color={colors.white}>
              {text2}
            </BarTextLeft>
          </LineBar>
        </BarBorder>
        <BarNumber color={colors.negative} space={5}>
          +{formatNumber(value2 - value1)}
        </BarNumber>
      </BarZone>
    </>
  );
};

KeywordBar.propTypes = {
  barHeight: PropTypes.number,
  value1: PropTypes.number.isRequired,
  value2: PropTypes.number.isRequired,
  text1: PropTypes.string,
  text2: PropTypes.string,
};

export { KeywordBar };
